import { Component, forwardRef, OnDestroy, OnChanges, OnInit, SimpleChanges, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { validatePassword, validateLoginPassword } from '@util/validators';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => PasswordInputComponent),
    },
  ],
})
export class PasswordInputComponent implements ControlValueAccessor, OnDestroy, OnChanges, OnInit {

  @Input() isPersistent: boolean;
  @Input()
  set resetPassword(needsReset: boolean) {
    if (needsReset) {
      this.passwordForm.patchValue({
        passwordValue: '',
      });
      this.passwordForm.markAsUntouched();
    }
  }
  @Input() needsPasswordDescription: boolean;
  passwordType: string;
  passwordShown: boolean;
  passwordForm: FormGroup;
  subscription: Subscription;

  constructor(private formBuilder: FormBuilder) {
    this.passwordForm = this.formBuilder.group({
      passwordValue: new FormControl(''),
    });
    this.passwordType = 'password';
    this.passwordShown = false;
    this.subscription = new Subscription();
   }

  togglePassword() {
    if (this.passwordType === 'password') {
      this.passwordShown = true;
      this.passwordType = 'text';
    } else {
      this.passwordShown = false;
      this.passwordType = 'password';
    }
  }

  propagateChange = (_: any) => {};

  writeValue(obj: any) { }

  registerOnChange(fn: any) {
    this.propagateChange = fn;
    this.subscription.add(this.passwordForm.valueChanges.subscribe(() => {
      fn(this.passwordForm.value);
    }));
  }
  registerOnTouched(fn: any) {
    this.propagateChange = fn;
  }
  ngOnDestroy(): void {
    this.passwordForm.patchValue({
      password: '',
    });
    this.subscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.needsPasswordDescription) {
      this.setPasswordValidator();
    }
  }

  ngOnInit(): void {
    this.setPasswordValidator();
  }

  private setPasswordValidator(): void {
    const passwordControl = this.passwordForm.get('passwordValue');
    if (passwordControl) {
      // Clear existing validators
      passwordControl.clearValidators();
      passwordControl.setValidators(
        this.needsPasswordDescription ? validatePassword : validateLoginPassword,
      );
      passwordControl.updateValueAndValidity();
    }
  }

}
